import React, { Fragment } from 'react'

import { Box, Typography } from '@mui/material'

import { useStyles } from '../styles'
import { useCheck } from '../context/useCheck'
import { DispatchZones } from './DispatchZones'
import { LoadingZones } from './LoadingZones'

/*
 * Copyright 2022-07-26 por Alfonso Moya Ecomsur Holding S.A ©
 * Detalle: se módifica DispatchValidation por cambio a useReducer + Context
 */

interface DispatchValidationProps {
  text: string
  isSuccess: boolean
}

export const DispatchValidation: React.FC<DispatchValidationProps> = ({
  text,
  isSuccess
}) => {
  const classes = useStyles()

  const {
    state: { isPickingStatus, loadingZones }
  } = useCheck()

  return (
    <Fragment>
      <Typography
        className={`${classes.dispatchValidationBase} ${
          isSuccess
            ? classes.dispatchValidationSuccess
            : classes.dispatchValidationError
        }`}
      >
        {text}
      </Typography>

      {isPickingStatus && (
        <Box className={`${classes.dispatchZones}`}>
          {loadingZones ? <LoadingZones /> : <DispatchZones />}
        </Box>
      )}
    </Fragment>
  )
}
